export const ErrorComponent = ({ message }: { message?: string }) => {
  return (
    <div className="cmp-filterable-list--error">
      <p>{message || 'Ups! something went wrong.'}</p>
    </div>
  )
}
